import '@jack-henry/jh-icons/icons-wc/icon-trash-can';
import { IpRestrictionAddress } from '@treasury/domain/backoffice/services/access/entities/ip-restriction-address.entity';
import { TmBaseComponent } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('tm-bo-ip-address')
export class IpAddressComponent extends TmBaseComponent {
    @property({ type: Boolean })
    public restricted: boolean = false;

    @property({ type: Number })
    public index!: number;

    @property({ type: Object })
    public ipAddress?: IpRestrictionAddress;

    public render() {
        return html`<div class="flex flex-row mb-2 gap-2 items-start">
            <div class="flex-1">
                <tm-input
                    class="hidden"
                    .name="ip.ipAddresses[${this.index}].entityId"
                    .initial=${this.ipAddress?.entityId}
                >
                </tm-input>
                <tm-input
                    .label=${'IP Address:'}
                    .type=${'ip'}
                    .minLength=${7}
                    .required=${true}
                    .name=${`ip.ipAddresses[${this.index}].ipAddress`}
                    ?disabled=${!this.restricted}
                    .initial=${this.ipAddress?.ipAddress}
                >
                </tm-input>
            </div>
            <div class="flex-1">
                <tm-input
                    .label=${'Name:'}
                    .initial=${this.ipAddress?.name}
                    .name=${`ip.ipAddresses[${this.index}].name`}
                    ?disabled=${!this.restricted}
                    .placeholder=${'IP Address Name'}
                    .required=${true}
                >
                </tm-input>
            </div>
            <div class="flex-0">
                <tm-button
                    class="mt-6"
                    importance="secondary"
                    @click=${() => this.handleDeleteIpAddress(this.ipAddress?.entityId ?? '')}
                    ?disabled=${!this.restricted}
                    isIcon
                    ><jh-icon-trash-can></jh-icon-trash-can>
                </tm-button>
            </div>
        </div>`;
    }

    private handleDeleteIpAddress(entityId: string) {
        this.dispatchEvent(
            new CustomEvent('delete', {
                detail: {
                    entityId,
                },
            })
        );
    }
}
